
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 5v16h28V5zm3.914 2H26.09a1.44 1.44 0 00-.09.5 1.5 1.5 0 002 1.414v8.176a1.451 1.451 0 00-.5-.09 1.5 1.5 0 00-1.5 1.5c0 .172.031.34.09.5H5.914A1.5 1.5 0 004.5 17c-.172 0-.34.031-.5.09V8.914A1.5 1.5 0 005.914 7zM16 9c-2.21 0-4 1.79-4 4v1h.203c.45 1.71 1.942 3 3.797 3 1.855 0 3.348-1.29 3.797-3H20v-1c0-2.21-1.79-4-4-4zm0 2c1.191 0 2 .809 2 2 0 1.191-.809 2-2 2-1.191 0-2-.809-2-2 0-1.191.809-2 2-2zm-7 .5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm14 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM2 22v2h1.004s14.336-.04 24.742 2.719l1.254.328V22h-2v1.09a1.451 1.451 0 00-.5-.09 1.51 1.51 0 00-1.45 1.11C14.778 21.987 3.013 22 3 22z"}})])
          )
        }
      }
    